<template>
  <div>
    <hr class="mt-0 mb-4" />

    <b-row>
      <b-col>
        <base-button
          v-if="$store.getters.getTipoPrivilegiosUsuario != 'G'"
          type="default"
          block
          class="mb-3"
          @click="abrirModalFormulario"
        >
          Crear nuevo Catecumeno
        </base-button>

        <tabla-catecumenos
          :editable="true"
          :cabecera="true"
          :datos="catecumenos"
          @editarElemento="editarCatecumeno"
          @eliminarElemento="eliminarCatecumeno"
        />
      </b-col>
    </b-row>

    <modal-catecumeno
      idModal="modal-form-catecumeno"
      :catecumeno="catecumeno"
      @guardaCatecumeno="guardarDatos"
    />
  </div>
</template>
<script>
import axios from "@/directives/axios.js";
import tablaCatecumenos from "@/components/Tables/TablaCatecumenos.vue";
import ModalCatecumeno from "@/components/modals/ModalCatecumeno.vue";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  components: {
    tablaCatecumenos,
    ModalCatecumeno,
  },
  props: {},
  data() {
    return {
      catecumeno: {
        fecha_inscripcion: new Date(),
        id_grupo_catequesis: undefined,
        nombre: undefined,
        apellido1: undefined,
        apellido2: undefined,
        fecha_nacimiento: undefined,
        colegio: undefined,
        curso_colegio: undefined,
        situacion_familiar: undefined,
        numero_hermanos: undefined,
        lugar_ocupa_hermanos: undefined,
        foto: undefined,
        domicilio: undefined,
        observaciones: undefined,
        profesion: undefined,
        activo: undefined,
        padre: {
          nombre: undefined,
          apellido1: undefined,
          apellido2: undefined,
          fecha_nacimiento: undefined,
          profesion: undefined,
          telefono: undefined,
          id: undefined,
        },
        madre: {
          nombre: undefined,
          apellido1: undefined,
          apellido2: undefined,
          fecha_nacimiento: undefined,
          profesion: undefined,
          telefono: undefined,
          id: undefined,
        },
      },
    };
  },

  computed: {
    catecumenos() {
      if (this.$store.getters.getListaCatecumenosPadres != undefined) {
        loader.close();
        return this.$store.getters.getListaCatecumenosPadres;
      } else {
        loader.open();
        this.$store.dispatch("recargaCatecumenosPadres");
        return null;
      }
    },
  },

  methods: {
    abrirModalFormulario() {
      this.resetCatecumeno();
      this.$nextTick(() => {
        this.$bvModal.show("modal-form-catecumeno");
      });
    },

    editarCatecumeno(value) {
      loader.open();
      axios({
        method: "GET",
        url: `/catecumenos/catecumeno?idCatecumeno=${value.id}`,
        withCredentials: true,
        data: value,
      })
        .then((data) => {
          loader.close();
          this.catecumeno = data.data.catecumeno;
          this.$nextTick(() => {
            this.$bvModal.show("modal-form-catecumeno");
          });
        })
        .catch(() => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un erro inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },

    guardarDatos(value) {
      loader.open();
      axios({
        method: "POST",
        url: `/catecumenos`,
        withCredentials: true,
        data: value,
      })
        .then((data) => {
          loader.close();
          this.$bvModal.hide("modal-form-catecumeno");
          swal
            .fire({
              title: `Datos cambiados Correctamente`,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            })
            .then(() => {
              this.$store.dispatch("recargaCatecumenosPadres", data.data);
              this.$store.dispatch("cargarCountCursosGrupos");
              this.$store.dispatch("recargaMadres");
              this.$store.dispatch("recargaPadres");
              this.resetCatecumeno();
            });
        })
        .catch(() => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un erro inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },

    eliminarCatecumeno(id) {
      loader.open();
      axios({
        method: "delete",
        url: `/catecumenos?id=${id}`,
        withCredentials: true,
      })
        .then((data) => {
          loader.close();
          this.$bvModal.hide("modal-form-catecumeno");
          swal
            .fire({
              title: `Datos Eliminados Correctamente`,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            })
            .then(() => {
              this.$store.dispatch("recargaCatecumenosPadres", data.data);
              this.$store.dispatch("cargarCountCursosGrupos");
              this.resetCatecumeno();
            });
        })
        .catch(() => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un erro inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
    resetCatecumeno() {
      this.catecumeno = {
        id: undefined,
        activo: undefined,
        nombre: undefined,
        apellido1: undefined,
        apellido2: undefined,
        fecha_nacimiento: undefined,
        numero_hermanos: undefined,
        lugar_ocupa_hermanos: undefined,
        id_colegio: undefined,
        id_curso_colegio: undefined,
        domicilio: undefined,
        observaciones: undefined,
        profesion: undefined,
        fecha_inscripcion: new Date(),
        id_grupo_catequesis: undefined,
        foto: undefined,
        nombre_foto: undefined,
        bautizo: {
          nombreParroquia: undefined,
          fecha: undefined,
          municipio: undefined,
          provincia: undefined,
          libro: undefined,
          folio: undefined,
          numero: undefined,
          entregada: 0,
        },
        situacion_familiar: undefined,
        padre: {
          nombre: undefined,
          apellido1: undefined,
          apellido2: undefined,
          fecha_nacimiento: undefined,
          profesion: undefined,
          telefono: undefined,
          id: undefined,
        },
        madre: {
          nombre: undefined,
          apellido1: undefined,
          apellido2: undefined,
          fecha_nacimiento: undefined,
          profesion: undefined,
          telefono: undefined,
          id: undefined,
        },
      };
    },
  },
};
</script>
<style scoped>
.row {
  display: -webkit-box;
}
</style>
